import * as React from "react"
import {Box} from "@mui/material";
import {ButtonSeeker, IconSeeker, ModalSeeker} from "@ui-seeker/core";

import {useReverseMatcherImageComparisonNavigator} from "../../@hooks";
import {reverseMatcherImageComparatorModalData} from "../../@signals";
import ReverseMatcherImageComparisonModalContainer from "./Container";
import ReverseMatcherImageComparisonModalCounter from "./Counter";
import ReverseMatcherImageComparisonModalArrow from "./Arrow";


export default function ReverseMatcherImageComparisonModal({  brandOptions=[], setSelectedSKU, saveMapping  }) {
	const { isOpen, numOptions, localIndex, handleNavigateLeft, handleNavigateRight } = useReverseMatcherImageComparisonNavigator(brandOptions, setSelectedSKU)

	return <ModalSeeker
		hideActions
		isOpen={isOpen}
		title="Image Comparison"
		controller={() => reverseMatcherImageComparatorModalData.value = {}}
		containerProps={{ fullScreen: true }}
	>
		<Box
			maxWidth={1}
			mx="auto"
			p={2}
		>
			<Box display="flex" flexDirection="column" gap={2}>
				<Box display="flex" alignItems="center" justifyContent="space-between" width={1}>
					<ReverseMatcherImageComparisonModalCounter
						numOptions={numOptions}
						localIndex={localIndex}
					/>

					<ButtonSeeker
						color="success"
						startIcon={<IconSeeker icon="badge-check" />}
						onClick={() => {
							saveMapping?.()
							reverseMatcherImageComparatorModalData.value = {}
						}}
					>
						Validate
					</ButtonSeeker>
				</Box>


				<Box
					display="flex"
					gap={2}
					alignItems="stretch"
					justifyContent="center"
					height="75vh"
					sx={{ position: 'relative' }}
				>
					<ReverseMatcherImageComparisonModalArrow
						orientation="left"
						brandOptionsLength={numOptions}
						localIndex={localIndex}
						onNavigate={handleNavigateLeft}
					/>
					<ReverseMatcherImageComparisonModalArrow
						orientation="right"
						brandOptionsLength={numOptions}
						localIndex={localIndex}
						onNavigate={handleNavigateRight}
					/>
					<ReverseMatcherImageComparisonModalContainer
						fullURL={reverseMatcherImageComparatorModalData.value?.fullUrlLeft}
						url={reverseMatcherImageComparatorModalData.value.urlLeft}
						label="Target"
						labelColor="default"
						productName={reverseMatcherImageComparatorModalData.value?.skuName}
					/>
					<ReverseMatcherImageComparisonModalContainer
						fullURL={reverseMatcherImageComparatorModalData.value?.fullUrlRight}
						url={reverseMatcherImageComparatorModalData.value.urlRight}
						label="Selected"
						labelColor="primary"
						productName={reverseMatcherImageComparatorModalData.value?.candidateName}
					/>
				</Box>
			</Box>
		</Box>
	</ModalSeeker>
}
